import { connectorIcons } from './assets'

export function getConnectorIcon (connectorType) {
    const t = connectorType || ''
    const connectorIcon = connectorIcons[t.toLowerCase()]
    return connectorIcon || connectorIcons.unknown
}
